import React from "react";
import ImageAttachment from "./ImageAttachment";
import VideoAttachment from "./VideoAttachment";
import DocumentAttachment from "./DocumentAttachment";
import { ChatAttachment } from "./types";

type Props = { attachment: ChatAttachment };

const Attachment = ({ attachment }: Props) => {
  if (attachment.mimeType.startsWith("image/")) return <ImageAttachment attachment={attachment} />;
  if (attachment.mimeType.startsWith("video/")) return <VideoAttachment attachment={attachment} />;
  return <DocumentAttachment attachment={attachment} />;
};

export default Attachment;
